import { filesSteps } from '@/components/Tutorial/steps/filesSteps';
import { setHasCompletedAnalysisTutorial } from '@/store/slices/tutorialSlice';
import { setHasCompletedFilesTutorial } from '@/store/slices/tutorialSlice';
import { TourProvider } from '@reactour/tour';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from './ThemeProvider';
import { CustomMask } from '@/components/Tutorial/CustomMask';
import { resetFilters, setSearchValue } from '@/store/slices/filesSlice';

const TourProviderWithMask = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const { theme } = useTheme();

  const resetTutorial = () => {
    dispatch(setHasCompletedAnalysisTutorial(false));
    dispatch(setHasCompletedFilesTutorial(false));
    dispatch(resetFilters());
    dispatch(setSearchValue(''));
    window.dispatchEvent(new Event('reactour-close'));
  };

  return (
    <TourProvider
      steps={filesSteps}
      beforeClose={resetTutorial}
      styles={{
        popover: (base) => ({
          ...base,
          bottom: '50px',
          right: '50px',
          top: 'inherit',
          left: 'inherit',
          transform: 'none',
          backgroundColor: theme === 'light' ? 'white' : '#161617',
          color:
            theme === 'dark'
              ? 'var(--color-text-light)'
              : 'var(--color-text-dark)',
        }),
        maskWrapper: (base) => ({
          ...base,
          backgroundColor:
            theme === 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(1px)',
          zIndex: 9998,
        }),
        maskArea: (base) => ({
          ...base,
          zIndex: 9998,
        }),
        maskRect: (base) => ({
          ...base,
          pointerEvents: 'none',
          zIndex: 9998,
        }),
        arrow: (base) => ({
          ...base,
          color: 'var(--color-bg-dark)',
          zIndex: 9999,
        }),
        controls: (base) => ({
          ...base,
          display: 'none',
        }),
      }}
      onClickMask={(props) => {
        if (props.currentStep < (props.steps?.length ?? 0) - 1) {
          props.setCurrentStep((currentStep) => currentStep + 1);
        }
      }}
    >
      <CustomMask />
      {children}
    </TourProvider>
  );
};

export const CustomTourProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <TourProviderWithMask>{children}</TourProviderWithMask>;
};
